export const Home: React.FC<any> = (_props) => {
  return <article> This is the home page.</article>;
};
